/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * 
 * Generated from: playbook/app/pb_kits/playbook/utilities/global-props.schema.json
 * Run: yarn generate:global-props-values
 */

const globalPropsValues = [
  {
    prop: "alignContent",
    type: "union",
    values: '"start" | "end" | "center" | "spaceBetween" | "spaceAround" | "spaceEvenly"',
    platforms: ["react","rails"]
  },
  {
    prop: "alignItems",
    type: "union",
    values: '"start" | "end" | "center" | "flexStart" | "flexEnd" | "stretch" | "baseline"',
    platforms: ["react","rails"]
  },
  {
    prop: "alignSelf",
    type: "union",
    values: '"start" | "end" | "center" | "auto" | "stretch" | "baseline"',
    platforms: ["react","rails"]
  },
  {
    prop: "border",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderBottom",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderLeft",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderRadius",
    type: "union",
    values: '"none" | "xs" | "sm" | "md" | "lg" | "xl" | "rounded"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderRight",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderTop",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderX",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "borderY",
    type: "union",
    values: '"none" | "default" | "active" | "default_thick" | "default_thicker" | "active_thick" | "active_thicker"',
    platforms: ["react","rails"]
  },
  {
    prop: "bottom",
    type: "union",
    values: '"xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"',
    platforms: ["react","rails"]
  },
  {
    prop: "columnGap",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "cursor",
    type: "union",
    values: '"auto" | "default" | "none" | "contextMenu" | "help" | "pointer" | "progress" | "wait" | "cell"',
    platforms: ["react","rails"]
  },
  {
    prop: "dark",
    type: "boolean",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "display",
    type: "union",
    values: '"none" | "flex" | "inline_flex" | "inline" | "inline_block" | "block" | "grid"',
    platforms: ["react","rails"]
  },
  {
    prop: "flex",
    type: "union",
    values: '"auto" | "initial" | "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12" | "none"',
    platforms: ["react","rails"]
  },
  {
    prop: "flexDirection",
    type: "union",
    values: '"row" | "column" | "rowReverse" | "columnReverse"',
    platforms: ["react","rails"]
  },
  {
    prop: "flexGrow",
    type: "union",
    values: '"0" | "1"',
    platforms: ["react","rails"]
  },
  {
    prop: "flexShrink",
    type: "union",
    values: '"0" | "1"',
    platforms: ["react","rails"]
  },
  {
    prop: "flexWrap",
    type: "union",
    values: '"wrap" | "nowrap" | "wrapReverse"',
    platforms: ["react","rails"]
  },
  {
    prop: "gap",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridArea",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridAutoColumns",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridAutoFlow",
    type: "union",
    values: '"row" | "column" | "dense" | "rowDense" | "columnDense"',
    platforms: ["react","rails"]
  },
  {
    prop: "gridAutoRows",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridColumn",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridRow",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridTemplateAreas",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridTemplateColumns",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "gridTemplateRows",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "groupHover",
    type: "boolean",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "height",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "hover",
    type: "object",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "inset",
    type: "boolean",
    values: [],
    platforms: ["react"]
  },
  {
    prop: "justifyContent",
    type: "union",
    values: '"start" | "end" | "center" | "spaceBetween" | "spaceAround" | "spaceEvenly"',
    platforms: ["react","rails"]
  },
  {
    prop: "justifyItems",
    type: "union",
    values: '"start" | "end" | "center" | "stretch"',
    platforms: ["react","rails"]
  },
  {
    prop: "justifySelf",
    type: "union",
    values: '"start" | "end" | "center" | "auto" | "stretch"',
    platforms: ["react","rails"]
  },
  {
    prop: "left",
    type: "union",
    values: '"xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"',
    platforms: ["react","rails"]
  },
  {
    prop: "lineHeight",
    type: "union",
    values: '"loosest" | "looser" | "loose" | "normal" | "tight" | "tighter" | "tightest"',
    platforms: ["react","rails"]
  },
  {
    prop: "margin",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginBottom",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginLeft",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginRight",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginTop",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginX",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "marginY",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "maxHeight",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "maxWidth",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "minHeight",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "minWidth",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "numberSpacing",
    type: "union",
    values: '"tabular"',
    platforms: ["react","rails"]
  },
  {
    prop: "order",
    type: "union",
    values: '"none" | "first" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12"',
    platforms: ["react","rails"]
  },
  {
    prop: "overflow",
    type: "union",
    values: '"scroll" | "visible" | "hidden" | "auto"',
    platforms: ["react","rails"]
  },
  {
    prop: "overflowX",
    type: "union",
    values: '"scroll" | "visible" | "hidden" | "auto"',
    platforms: ["react","rails"]
  },
  {
    prop: "overflowY",
    type: "union",
    values: '"scroll" | "visible" | "hidden" | "auto"',
    platforms: ["react","rails"]
  },
  {
    prop: "padding",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingBottom",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingLeft",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingRight",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingTop",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingX",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "paddingY",
    type: "union",
    values: '"none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "auto" | "initial" | "inherit"',
    platforms: ["react","rails"]
  },
  {
    prop: "position",
    type: "union",
    values: '"relative" | "absolute" | "fixed" | "sticky" | "static"',
    platforms: ["react","rails"]
  },
  {
    prop: "right",
    type: "union",
    values: '"xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"',
    platforms: ["react","rails"]
  },
  {
    prop: "rowGap",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "shadow",
    type: "union",
    values: '"none" | "deep" | "deeper" | "deepest"',
    platforms: ["react","rails"]
  },
  {
    prop: "textAlign",
    type: "union",
    values: '"start" | "end" | "left" | "right" | "center" | "justify" | "justifyAll" | "matchParent"',
    platforms: ["react","rails"]
  },
  {
    prop: "top",
    type: "union",
    values: '"xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"',
    platforms: ["react","rails"]
  },
  {
    prop: "truncate",
    type: "union",
    values: '"none" | "1" | "2" | "3" | "4" | "5"',
    platforms: ["react","rails"]
  },
  {
    prop: "verticalAlign",
    type: "union",
    values: '"baseline" | "super" | "top" | "middle" | "bottom" | "sub" | "text-top" | "text-bottom"',
    platforms: ["react","rails"]
  },
  {
    prop: "width",
    type: "string",
    values: [],
    platforms: ["react","rails"]
  },
  {
    prop: "zIndex",
    type: "union",
    values: '"1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "max"',
    platforms: ["react","rails"]
  }
];

export default globalPropsValues;
